import { UIHeading1, UIHeading2, UIText2 } from '@cian/ui-kit';
import classNames from 'classnames';
import * as React from 'react';

import { RosreestrPlan } from 'shared/components/RosreestrPlan';

import { InfoBlock } from './components/InfoBlock';
import * as styles from './styles.css';
import { IRosreestrInfo } from '../../types/offerData';
import { CollapseButton } from '../CollapseButton';

export interface IRosreestrInfoNewProps extends IRosreestrInfo {
  onExpand(): void;
  showExpandButton: boolean;
  cadastralMapRef?: (node?: Element | null) => void;
  onCadastralMapClick(): void;
}

export const RosreestrInfoNew: React.VFC<IRosreestrInfoNewProps> = ({
  header,
  deck,
  parts,
  bottom,
  cadastralMapPreview,
  onExpand,
  showExpandButton,
  cadastralMapRef,
  onCadastralMapClick,
}) => {
  return (
    <div>
      <div className={styles['header']}>
        <UIHeading1 color="black_100">{header}</UIHeading1>
        <UIText2>{deck}</UIText2>
      </div>

      {bottom && (
        <div className={styles['date']}>
          <UIText2 color="gray60_100">{bottom}</UIText2>
        </div>
      )}

      {cadastralMapPreview && (
        <>
          <div className={classNames(styles['content'], styles['with-map'])}>
            <div>
              <InfoBlock {...parts[0]} />
              {showExpandButton && (
                <div className={styles['collapse-button']}>
                  <CollapseButton onClick={onExpand} isCollapsed collapsedText="Читать дальше" />
                </div>
              )}
            </div>

            <div className={styles['cadastral-map-container']} ref={cadastralMapRef}>
              <div data-testid="col-sub-header" className={styles['sub-header']}>
                <UIHeading2>План участка</UIHeading2>
              </div>
              <RosreestrPlan {...cadastralMapPreview} onPreviewClick={onCadastralMapClick} />
            </div>
          </div>
          {parts[1] && (
            <div className={styles['content-bottom']}>
              <InfoBlock {...parts[1]} />
            </div>
          )}
        </>
      )}

      {!cadastralMapPreview && (
        <div>
          <div className={styles['content']}>
            {parts.map((part, index) => (
              <InfoBlock {...part} key={index} />
            ))}
          </div>
          {showExpandButton && (
            <div className={styles['collapse-button']}>
              <CollapseButton onClick={onExpand} isCollapsed collapsedText="Читать дальше" />
            </div>
          )}
        </div>
      )}
    </div>
  );
};
